import { mediaQueries, size, typography } from '@everlywell/leaves';
import styled from 'styled-components';

interface MarkdownTextProps {
  bulletedListStyle?: boolean;
}

export const MarkdownText = styled.div<MarkdownTextProps>`
  ${typography.bodyTextSmall}

  ${mediaQueries.forTabletHorizontalUp} {
    ${typography.bodyText}
  }

  ol,
  ul {
    padding-left: ${size.lg}px;
  }

  li {
    list-style-type: ${(props) =>
      props.bulletedListStyle ? 'disc' : 'decimal'};
  }

  p {
    margin-bottom: ${size.md}px;
  }
`;
